/*
 * Copyright (C) 2026 - Potentially Ltd
 *
 * Please see distribution for license.
 */

import { Framework, SkillTaxonomy } from '../admin/admin.model';

export enum CourseAwardIssuanceMode {
  MANUAL = 'MANUAL',
  MEMBER_CLAIM = 'MEMBER_CLAIM',
  DATE = 'DATE',
  PASS_ASSIGNMENTS = 'PASS_ASSIGNMENTS',
  AUTOMATIC = 'AUTOMATIC',
  COMPLETION = 'COMPLETION',
  ENROLLMENT = 'ENROLLMENT',
}

export type CourseAwardConfiguration =
  | { mode: CourseAwardIssuanceMode.MANUAL }
  | { mode: CourseAwardIssuanceMode.MEMBER_CLAIM }
  | { mode: CourseAwardIssuanceMode.AUTOMATIC }
  | { mode: CourseAwardIssuanceMode.COMPLETION }
  | { mode: CourseAwardIssuanceMode.ENROLLMENT }
  | { mode: CourseAwardIssuanceMode.DATE; automaticIssueTime: string }
  | { mode: CourseAwardIssuanceMode.PASS_ASSIGNMENTS; criteria: CourseAwardCriteria[] };

export type CourseAwardCriteria = CourseAwardCriteriaLmsScore;

export type CourseAwardCriteriaLmsScore = {
  type: 'LMS_SCORE';
  gradeId: string;
  threshold: number;
  gradeName?: string;
  maxScore?: number;
};

export interface SkillsDetails {
  frameworkSkills: FrameworkSkillDetails[];
  tagSkills: TagSkillDetails[];
  allSkillsSelected: boolean;
  awardConfiguration?: CourseAwardConfiguration;
}

export interface FrameworkSkillDetails {
  frameworkUid: string;
  frameworkName: string;
  tagUid: string;
  tagTitle: string;
  tagDescription?: string | null;
  levelUid?: string | null;
  levelName?: string | null;
  awardConfiguration: CourseAwardConfiguration;
}

export interface TagSkillDetails {
  tagUid: string;
  tagTitle: string;
  tagDescription?: string | null;
  awardConfiguration: CourseAwardConfiguration;
}

export interface SetPlaylistSkillsRequest {
  frameworkSkills: FrameworkSkill[];
  tagSkills: TagSkill[];
}

export interface FrameworkSkill {
  frameworkUid: string;
  tagUid: string;
  levelUid?: string | null;
  awardConfiguration: CourseAwardConfiguration;
}

export interface TagSkill {
  tagUid: string;
  awardConfiguration: CourseAwardConfiguration;
}

export interface FrameworksDetailsResponse {
  frameworks: Framework[];
  skillTaxonomies: SkillTaxonomy[];
}
